/* eslint-disable no-useless-escape */
// The WHATWG input[type=email] pattern, with at least one dot in the domain.
export const emailRegex: RegExp =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

// Any character that isn't a letter or digit counts as the special character.
export const passwordRegex: RegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export const dateRegex: RegExp =
  /^(0[1-9]|1[012])([^$%&|<>#]*$)[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/;

export const NameRegex: RegExp =
  /^([a-zA-ZZáéíóúÁÉÍÓÚÑñÇçüÜ ]*$)([^$%&|<>@#0-9]*$)/;

export const simeraEmailRegex = /^\w+([-+.']\w+)*@?(simera.me)$/;

export const phoneRegex = /^\d+$/;

export const stringRegex = /^[A-Za-z]+$/;

export const urlRegex: RegExp =
  /^(http(s)?:\/\/)?(www\.)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
